module.exports = __webpack_public_path__ + "static/media/not-fighting-power.60f24bbd.png";